var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1682_4084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7927 15.6121H5.88715V18.3899H22.7927L15.3427 25.8399L17.3066 27.8038L28.1094 17.001L17.3066 6.19824L15.3427 8.16213L22.7927 15.6121Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1682_4084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3333,
    height: 33.3333,
    fill: "white",
    transform: "matrix(-1 0 0 1 33.665 0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.64d03301dcb352321adca60f2489b947.svg";
export { ForwardRef as ReactComponent };